import {defineStore} from "pinia/dist/pinia";

export const useApplicationStore = defineStore('ApplicationStore', {
    state() {
        return {
            applicationState: 'assicurati-credito',
            ssoSessionState:false,
            editingState: false,
            setScrollPositionYState: 0
        }
    },
    getters: {
        applicationCode() { return this.applicationState },
        editing() { return this.editingState },
        scrollPositionY() { return this.setScrollPositionYState }
    },
    actions: {
        startSsoSession(){ this.ssoSessionState = true },
        stopSsoSession(){ this.ssoSessionState = false },
        setEditing(value) { this.editingState = value},
        setScrollPositionY(scrollPositionY) { this.setScrollPositionYState = scrollPositionY},
        setApplicationCode(code) { this.applicationState = code}
    }
})